<template>
  <div class="mallShopGoodsMore">
    <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
      <van-list
          v-model="loading"
          :finished="finished"
          :error.sync="isError"
          error-text="请求失败，点击重新加载"
          finished-text="没有更多了"
          @load="onLoad"
      >
        <div class="popular-list" v-if="$route.query.typeId==='3'">
          <div class="list" v-for="(item, i) in dataList" :key="i" @click="goDetail(item)">
            <div class="img-con">
              <img class="img" :src="item.coverPath + '?imageView2/0/w/200/h/150'" alt="">
            </div>
            <div class="text-con">
              <div class="list-title"><span class="type">{{ knowledgeTypeName(item.courseType) }}</span>{{ item.title }}</div>
              <div class="sub-text">
                <span class="num">已更新{{ item.currentCourseCount }}期</span>
                <span class="num">收藏:{{ item.collectUserCount }}</span>
                <span class="num">已售:{{ item.salesVolume }}</span>
                <span class="price">{{ item.sellPrice===0?'免费':('￥'+item.sellPrice) }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="popular-list" v-if="$route.query.typeId==='2'">
          <div class="list" v-for="(item, i) in dataList" :key="i" @click="goDetail(item)">
            <div class="img-con">
              <img class="img" :src="item.coverPath + '?imageView2/0/w/200/h/150'" alt="">
            </div>
            <div class="text-con">
              <div class="list-title"><span class="type">{{ knowledgeTypeName(item.courseType) }}</span>{{ item.title }}</div>
              <div class="sub-text">
                <span class="num" v-if="item.courseType!==null">时长:{{ item.duration }}min</span>
                <span class="num">收藏:{{ item.collectUserCount }}</span>
                <span class="num">已售:{{ item.salesVolume }}</span>
                <span class="price">{{ item.sellPrice===0?'免费':('￥'+item.sellPrice) }}</span>
              </div>
            </div>
          </div>
        </div>

      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { getShopHomeInfo } from '@/api/mall/mallGoods'
export default {
  components: {
  },
  data(){
    return {
      dataList: [], // 列表数据
      refreshLoading: false,

      loading: false,
      finished: false,
      isError: false,

      page: 1,
      size: 10,
    }
  },
  methods: {
    onRefresh(){
      this.page = 1;
      window.setTimeout(()=>{
        this.finished = false;
        this.dataList = [];
        this.refreshLoading = false;
        window.scrollTo(0, 0);
      },100)
    },
    onLoad() {
      let req = {
        shopId: this.$route.query.shopId,
        typeId: this.$route.query.typeId,
        page: this.page,
        size: this.size
      }
      if(this.$route.query.inviteUserId){
        req.inviteUserId = this.$route.query.inviteUserId
      }
      getShopHomeInfo(req).then(res => {
        let dataList = [];
        if(this.$route.query.typeId==='2'){ // 课程
          dataList = res.data.courseVos || [];
        }else if(this.$route.query.typeId==='3'){ // 专栏
          dataList = res.data.courseSeriesVos || [];
        }

        if(dataList.length>0){ //是否有数据
          // 如果是第一页需手动制空列表
          if (this.page === 1){
            this.dataList = [];
          }
          // 把请求到的数据添加到列表
          this.dataList = this.dataList.concat(dataList)
          this.page++
          this.loading = false
        }else {
          this.loading = false;
          this.finished = true;
        }
      }).catch(() => {
        this.error = true;
      })
    },



    // 跳转至商品详情
    goDetail(item) {
      let query = {goodsId: item.goodsId, shopId: this.$route.query.shopId, courseType: item.courseType||null };
      if(this.$route.query.inviteUserId){
        query.inviteUserId = this.$route.query.inviteUserId
      }
      this.$router.push({name: 'goodsDetail', query })
    },
  }
}
</script>

<style lang="less" scoped>
.mallShopGoodsMore{
  .popular-list{
    .list{
      height: 102px;
      padding: 12px;
      display: flex;
      box-shadow: 0 1px 0 0 #edecec;
      .img-con{
        width: 100px;
        height: 75px;
        position: relative;
        .img{
          display: block;
          width: 100px;
          height: 75px;
        }
      }
      .text-con{
        flex: 1;
        padding-left: 10px;
        .list-title{
          margin-bottom: 21px;
          font-size: 14px;
          height: 38px;
          color: #2b2b2b;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          .type{
            margin: 0 5px 0 0;
            font-size: 9px;
            border: .75px solid #1585f3;
            color: #1585f3;
            border-radius: 2px;
            padding: 1px 2.5px;
          }
        }
        .sub-text{
          font-size: 9px;
          color: #999;
          .num{
            padding-right: 6px;
          }
          .price{
            font-size: 14px;
            color: #f34b4b;
            float: right;
          }
        }
      }
    }
  }
}
</style>